<div id="login" class="page container">
  <h1>{{"copy.label.LOGIN.header"|copy|async}}</h1>
  <!-- <mtc-alert></mtc-alert> -->
  
  <div class="content col-md-12 " *ngIf="('RVSonly'|copy|async) > today">
    <div class="row">
      <div class="d-flex loginFlexContainer justify-content-between">
       <div [innerHTML]='"copy.html.logintext1"|copy|async' class="login-info"></div>
        <!-- <div [innerHTML]='"login.logintext"|content|async' class="login-info"></div> -->

        <!--Login tab with OTP off-->
        <section class="agendaTabs" *ngIf="('OTP'|copy|async) ==='false'">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
            <li class="nav-item" [ngbNavItem]="1" *ngIf="!onsite" >
              <button ngbNavLink>
                <span class="day">
                  <div [innerHTML]="'copy.label.LOGIN.newlogin.header' | copy | async"></div>
                </span>
                <span class="curve"></span>
              </button>
              <ng-template ngbNavContent>
                <app-initial-login></app-initial-login>
              </ng-template>
            </li>
            <li class="nav-item" [ngbNavItem]="2">
              <button ngbNavLink>
                <span class="day">
                  <div [innerHTML]="'copy.label.LOGIN.oldlogin.header' | copy | async"></div>
                </span>
                <span class="curve"></span>
              </button>
              <ng-template ngbNavContent>
                <app-rvs-confirmation-code *ngIf="('OTP'|copy|async) ==='false'"></app-rvs-confirmation-code>
                <!-- <app-otp *ngIf="('OTP'|copy|async) ==='true'"></app-otp> -->
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </section>
        <!-- End Login tab with OTP off-->

        <!--Login tab with OTP on-->
        <section class="agendaTabs" *ngIf="('OTP'|copy|async) ==='true'">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
            <li class="nav-item" [ngbNavItem]="1" *ngIf="!onsite ">
              <button ngbNavLink>
                <span class="day">
                  <div [innerHTML]="'copy.label.LOGIN.newlogin.header' | copy | async"></div>
                </span>
                <span class="curve"></span>
              </button>
              <ng-template ngbNavContent>
                <app-initial-login></app-initial-login>
              </ng-template>
            </li>
            <li class="nav-item" [ngbNavItem]="2">
              <button ngbNavLink style="height: 100% !important">
                <span class="day">
                  <div [innerHTML]="'copy.label.OTP.emailEntry' | copy | async"></div>
                </span>
                <span class="curve"></span>
              </button>
              <ng-template ngbNavContent>
                <!-- <app-rvs-confirmation-code *ngIf="('OTP'|copy|async) ==='false'"></app-rvs-confirmation-code> -->
                <app-otp *ngIf="('OTP'|copy|async) ==='true'"></app-otp>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </section>
        <!--End Login tab with OTP on-->
        <div [innerHTML]='"copy.html.logintext2"|copy|async' class="login-info mt-4"></div>
      </div>
    </div>
  </div>

  <!--after RVS day -->
  <div class="content col-md-12 " *ngIf="('RVSonly'|copy|async) <= today">
    <div class="row">
      <div class="d-flex loginFlexContainer justify-content-between">
       <div [innerHTML]='"copy.html.onsiteLoginText"|copy|async' class="login-info" *ngIf="('SiteClosed ' |copy|async) > today"></div>
       <div [innerHTML]='"copy.html.closedLoginText"|copy|async' class="login-info" *ngIf="('SiteClosed ' |copy|async) <= today"></div>
        <!-- <div [innerHTML]='"login.logintext"|content|async' class="login-info"></div> -->

        <!--Login tab with OTP off-->
        <section class="agendaTabs" *ngIf="('OTP'|copy|async) ==='false' && ('SiteClosed ' |copy|async) > today">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
            <li class="nav-item" [ngbNavItem]="2">
              <button ngbNavLink>
                <span class="day">
                  <div [innerHTML]="'copy.label.LOGIN.oldlogin.header' | copy | async"></div>
                </span>
                <span class="curve"></span>
              </button>
              <ng-template ngbNavContent>
                <app-rvs-confirmation-code *ngIf="('OTP'|copy|async) ==='false'"></app-rvs-confirmation-code>
                <!-- <app-otp *ngIf="('OTP'|copy|async) ==='true'"></app-otp> -->
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </section>
        <!-- End Login tab with OTP off-->

        <!--Login tab with OTP on-->
        <section class="agendaTabs" *ngIf="('OTP'|copy|async) ==='true' && ('SiteClosed ' |copy|async) > today">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
            <li class="nav-item" [ngbNavItem]="1">
              <button ngbNavLink>
                <span class="day">
                  <div [innerHTML]="'copy.label.OTP.emailEntry' | copy | async"></div>
                </span>
                <span class="curve"></span>
              </button>
              <ng-template ngbNavContent>
                <!-- <app-rvs-confirmation-code *ngIf="('OTP'|copy|async) ==='false'"></app-rvs-confirmation-code> -->
                <app-otp *ngIf="('OTP'|copy|async) ==='true'"></app-otp>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </section>
        <!--End Login tab with OTP on-->
      </div>
    </div>
  </div>
</div>
